






import './styles/App.css';
import React from 'react'
import { AudioPlayer } from './audioplayer/audioplayer'
import { SimpleSlider } from './carousel/carousel'
import { PageTemplate } from './page_template'



// Firebase App (the core Firebase SDK) is always required and must be listed first
//! import firebase from "firebase/app";
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
//! import "firebase/analytics";

// Add the Firebase products that you want to use
// import "firebase/auth";
//! import "firebase/firestore";

// var firebaseConfig = {
//   apiKey: "AIzaSyApbScEstu-Dt9d0y1IkweORd4oD8HQ9WA",
//   authDomain: "nunisynth-website.firebaseapp.com",
//   projectId: "nunisynth-website",
//   storageBucket: "nunisynth-website.appspot.com",
//   messagingSenderId: "814798004748",
//   appId: "1:814798004748:web:4783e7c7ceb058970b0429",
//   measurementId: "G-MPYFYW9D5V"
// };
// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);
// firebase.analytics();

// const db = firebase.firestore()

// const registeredEmails = {}

// db.collection('emails').get().then(query => {
//   query.forEach(result => 
//     registeredEmails[result.get('email')] = true)

//   // console.log('registered emails = ',registeredEmails)
// })




export function Home() {

  const audioPlayer = React.createRef()

  function pressAudioPlayerButton() {
    audioPlayer.current.show()
    audioPlayer.current.togglePlay()
  }
  
  return (
    <div className="App">
      <header className="App-header">
        <div className="mytoolbar">

        <span className="flex-center">
            <span className="nuni-logo"></span>
        </span>
        
        {/* <span className="toolbar-part-3">🛒🔍</span> */}
        <span className="toolbar-part-3" style={{ fontSize: '1.125rem', color: '#888' }}> 
            VERSION 1.1.1 — 5/17/2021 
        </span>
        </div>

        <div className="main-abstract">
          <h1 className="title"> NUNISYNTH </h1>
        </div>
      </header>

      <div className="main-content">
        
        <PageTemplate>
            <div className="section section-1">
            <div className="row">
                <div className="text-stuff">
                <h2> MODULAR SANDBOX </h2>
                <ul>
                    <li className="list-item">Experiment with graph-based audio synthesis</li>
                    <li className="list-item">Construct rich sounds using subtractive synthesis,
                    additive synthesis, FM synthesis and granular synthesis
                    </li>
                    <li className="list-item">
                    Build instruments, effects, and complex audio functions. 
                    All sounds in the following demos are created in NUNISYNTH, 
                    not recorded from outside.
                    </li>
                </ul>
                <div className="circle-button" onClick={pressAudioPlayerButton}><div className="icono-play"/></div>
                &nbsp; NUNISYNTH Demos
                </div>
                <div className="pic nunisynth-pic _0"></div>
            </div>
            <AudioPlayer ref={audioPlayer}/>
            </div>

            <div className="section">
                <div className="center">
                    <h2> NEXT LEVEL EXPERIMENTATION </h2>
                    <div className="margin _0"> 
                        NUNISYNTH gives you unique tools for creating and processing sounds 
                    </div>
                    <SimpleSlider/>
                </div>
            </div>

            <div className="section center" style={{ margin: `4em 0` }}>
                
                <h2> REACH UNTOLD HEIGHTS </h2>
                    <ul className="list2">
                        <li className="list-item">Quick sound design prototyping</li>
                        <li className="list-item">Unlimited polyrhythmic sequencers</li>
                        <li className="list-item">Special abstractions</li>
                        <li className="list-item">Smooth workflow</li>
                    </ul>
                <div className="pic _3"></div>
            </div>
        </PageTemplate>

        {/* <div className="card v-flex">
          <h5 className="flex">Receive NUNISYNTH Information</h5>
          <span ref={message} />
          <div className="flex">
            <input ref={textInput} type="text" placeholder="Email" />
            <button onClick={handleClick} className="sendbtn">Send</button>
          </div>
        </div> */}

        {/* <iframe className="yt-demo" width="560" height="315" src="https://www.youtube.com/embed/B1_s81mjIpU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe> */}
          
      </div>
    </div>
  );
}